<template>
    <div class="card mb-3">
        <div class="card-header">
            Search of {{ searchDetailsData.label }}
        </div>
        <div class="card-body">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="flexCheckDefault"
                    :checked="getSearchDetailsIndex(citizen, searchDetailsData.value as string) > -1"
                    @change="handleSearchPerformedChange($event, citizen, searchDetailsData.value as string)">
                <label class="form-check-label" for="flexCheckDefault">
                    Search Performed
                </label>
            </div>
            <div class="hstack gap-2" v-if="citizen != undefined && getSearchDetailsIndex(citizen, searchDetailsData.value as string) != -1">
                <div class="inputWrapper">
                    <div class="validationSideBySideDiv">
                        <div class="left">
                            <label style="font-weight:bold;">Basis for Search</label>
                        </div>
                        <div class="right">
                            <span style="color:Red;visibility:hidden;">Required</span>
                        </div>
                    </div>
                    <SelectField
                        v-model="citizen.search_details![getSearchDetailsIndex(citizen, searchDetailsData.value as string)].basis_for_search"
                        :select-items="contactsStore.getSearchBasis" :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                    </SelectField>
                </div>
                <div class="inputWrapper">
                    <div class="validationSideBySideDiv">
                        <div class="left">
                            <label style="font-weight:bold;">Requested Permission</label>
                        </div>
                        <div class="right">
                            <span style="color:Red;visibility:hidden;">Required</span>
                        </div>
                    </div>
                    <SelectField v-model="citizen.search_details![getSearchDetailsIndex(citizen, searchDetailsData.value as string)].requested_permission"
                        :select-items="contactsStore.getYesNo" :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                    </SelectField>
                </div>
                <div class="inputWrapper">
                    <div class="validationSideBySideDiv">
                        <div class="left">
                            <label style="font-weight:bold;">Granted Permission</label>
                        </div>
                        <div class="right">
                            <span style="color:Red;visibility:hidden;">Required</span>
                        </div>
                    </div>
                    <SelectField
                        v-model="citizen.search_details![getSearchDetailsIndex(citizen, searchDetailsData.value as string)].granted_permission"
                        :select-items="contactsStore.getYesNoUnknown" :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                    </SelectField>
                </div>
                <div class="inputWrapper">
                    <div class="validationSideBySideDiv">
                        <div class="left">
                            <label style="font-weight:bold;">Contraband Found</label>
                        </div>
                        <div class="right">
                            <span style="color:Red;visibility:hidden;">Required</span>
                        </div>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="flexCheckDefault"
                            v-model="citizen.search_details![getSearchDetailsIndex(citizen, searchDetailsData.value as string)].contraband_found">
                    </div>
                </div>
            </div>
            <div class="container-fluid mt-3"
                v-if="citizen != undefined && citizen.search_details != undefined && getSearchDetailsIndex(citizen, searchDetailsData.value as string) != -1">
                <h4>Property Seized</h4>
                <div class="row border bg-light d-flex align-items-center" style="height: 56px;">
                    <div class="col-5 h-100 d-flex align-items-center">Property Description</div>
                    <div class="col-5 h-100 d-flex align-items-center border-start">Basis for Seizure</div>
                    <div class="col-2 h-100 d-flex align-items-center border-start">
                        <button class="btn btn-primary" @click.prevent="handlePropertySeizedAddClick(citizen!.search_details![getSearchDetailsIndex(citizen, searchDetailsData.value as string)])">Add</button>
                    </div>
                </div>
                <div class="row border d-flex align-items-center"
                    v-for="(seizedProperty, index) in citizen.search_details[getSearchDetailsIndex(citizen, searchDetailsData.value as string)].seized_property" :key="keyColumn">
                    <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-5 p-2 text-center">
                        <SelectField v-model="seizedProperty.property_description"
                            :select-items="contactsStore.getPropertyType" :is-horizontal="false" :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                        </SelectField>
                    </div>
                    <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-5 p-2 text-center">
                        <SelectField v-model="seizedProperty.seized_basis"
                            :select-items="contactsStore.getPropertySeizureBasis" :is-horizontal="false"
                            :is-required="true" :ref="(el) => { addValidatableComponent(el) }">
                        </SelectField>
                    </div>
                    <div :class="{ 'bg-light': isAlternatingRow(index) }" class="col-2 p-2 mt-1 text-end">
                        <button class="btn-close me-3" aria-label="Remove"
                            @click.prevent="handleRemove(citizen!.search_details![getSearchDetailsIndex(citizen, searchDetailsData.value as string)].seized_property, index)"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { SelectItem } from '../../types';
import { useContactsStore } from '../../stores/contactsStore';
import {storeToRefs} from 'pinia';
import SelectField from '../Misc/SelectField.vue';
import AgeExactRangeRadioButtons from '../Misc/AgeExactRangeRadioButtons.vue';
import AgeSelectWithRange from '../Misc/AgeSelectWithRange.vue';
import { Citizen, WhatSearched, SearchDetails, SeizedProperty } from './schema';
import useValidation from '../Misc/validationUtils';


export default defineComponent({
    components: {
        SelectField,
        AgeExactRangeRadioButtons,
        AgeSelectWithRange
    },
    props: {
        searchDetailsData: {
            readonly: true,
            default: () => { },
            type: Object as PropType<SelectItem>
        },
        searchDetailsIndex: Number,
        index: {
            default: -1,
            type: Number
        },

    },
    setup() {

        const contactsStore = useContactsStore();
        var {contactFullReport} = storeToRefs(useContactsStore());
        const keyColumn = 'generated_id';

        const {validatableComponentArray, triggerValidation, addValidatableComponent } = useValidation();

        return { contactsStore, contactFullReport, keyColumn, validatableComponentArray, isValid:triggerValidation, addValidatableComponent };
    },
    computed: {
        citizen(): Citizen | undefined {
            if (this.contactFullReport!.citizens == null || this.index >= this.contactFullReport!.citizens.length) {
                return undefined;
            }

            return this.contactFullReport!.citizens[this.index];
        }
    },
    methods: {
        isAlternatingRow(index: number): boolean {
            return index % 2 == 1;
        },
        getSearchLabel(whatSearched: string): String {
            let label = "";
            switch (whatSearched) {
                case "P":
                    label = "Search of Person";
                    break;
                case "T":
                    label = "Search of Property";
                    break;
                case "V":
                    label = "Search of Vehicle";
                    break;
                default:
                    label = "Search";
                    break;
            }

            return label;
        },
        getSearchDetailsIndex(citizen: Citizen | undefined, whatSearchValue: string): number {
            if (citizen == undefined) {
                return -1;
            }

            if (citizen.search_details == undefined) {
                citizen.search_details = [];
            }

            return citizen.search_details.findIndex(f => f.what_searched === whatSearchValue);
        },
        handleSearchPerformedChange(event: any, citizen: Citizen | undefined, whatSearchValue: string) {
            
            if (citizen == undefined) {
                return;
            }

            let index = this.getSearchDetailsIndex(citizen, whatSearchValue);

            if (index === -1) {
                citizen.search_details!.push({
                    basis_for_search: undefined,
                    contraband_found: false,
                    granted_permission: undefined,
                    requested_permission: false,
                    seized_property: undefined,
                    what_searched: whatSearchValue as WhatSearched
                });
            }
            else if (index > -1 && citizen.search_details) {
                this.handleRemove(citizen.search_details, index);
            }
        },
        handleRemove(array: any, index: number) {
            array.splice(index, index >= 0 ? 1 : 0);
        },
        handlePropertySeizedAddClick(searchDetails:SearchDetails) {
            if(searchDetails.seized_property == undefined){
                searchDetails.seized_property = [] as SeizedProperty[];
            }

            searchDetails.seized_property.push({} as SeizedProperty);
        }
    },
})
</script>